import {TableCell} from "@mui/material";
import {styled} from "@mui/material/styles";

import {greyishBlue100} from "assets/jss/main";

// DS 2.0 product row cell: 20px row padding, 32px between columns (16px on
// each side), content aligned to the top of the row.
// The 32px between columns is fixed padding, so it never grows — but the CELL does.
// In table-layout auto the browser shares spare width across every column in
// proportion to its content, and since content is flush left the surplus shows up to
// its right, reading as a wider gap. The DS model is the opposite: fixed columns stay
// at their content width and the last one swallows the leftover. `width: 1px` asks
// each column to shrink to content (max-content still acts as the floor), and the
// 100% on the last cell claims everything that is left.
// The `&&` is load-bearing. styled(TableCell) does NOT win the padding cascade against
// MUI's own TableCell styles: emotion injects the wrapped component's styles after the
// wrapper's, and at equal specificity the later rule wins — so a plain `padding` here
// resolves to MUI's 16px instead of the DS values, taking the row's 20px padding and the
// 32px gutters with it (both lists also pass padding="none" to <Table>, which is in the
// same fight). Doubling the class outranks it. Locked by listingTableCellPadding.test.js.
const ListingTableCell = styled(TableCell)(({theme}) => ({
    verticalAlign: 'top',
    borderBottom: `1px solid ${greyishBlue100}`,
    width: '1px',
    '&&': {
        padding: '20px 16px'
    },
    '&&:first-of-type': {
        paddingLeft: '20px'
    },
    '&&:last-of-type': {
        paddingRight: '20px'
    },
    '&:last-of-type': {
        width: '100%',
        // In auto table layout a percentage column still feeds its max-content into the
        // table's intrinsic width, and wrapping content lays out SINGLE-LINE for that
        // measure — a row of many stock badges inflated the table way past its container
        // into horizontal scroll while this column sat far above its floor. maxWidth: 0
        // takes the content out of the intrinsic sizing so the column really is
        // "whatever is left"; the cell then needs its own floor since the content's
        // min width no longer protects it — 271px is the 235px content floor of the
        // stock cell plus this cell's 16px + 20px padding (border-box).
        maxWidth: 0,
        minWidth: '271px'
    },
    // Mobile keeps two columns (image, article): 16px row padding and a single
    // 16px gutter, and the article column may go under the desktop floor since
    // everything in it wraps or truncates. Declared last so it beats the
    // desktop rules above at equal specificity.
    [theme.breakpoints.down('sm')]: {
        '&&': {
            padding: '16px 8px'
        },
        '&&:first-of-type': {
            paddingLeft: '16px'
        },
        '&&:last-of-type': {
            paddingRight: '16px'
        },
        '&:last-of-type': {
            minWidth: '160px'
        }
    }
}));

// the row checkbox stays vertically centered
export const ListingCheckboxTableCell = styled(ListingTableCell)({
    verticalAlign: 'middle'
});

export default ListingTableCell;
